import fetch from '@/plugin/axios'

export function getLandingExperienceModelList (data) {
  return fetch({
    url: '/api/common/landing-experience-model/list',
    method: 'Post',
    data: data
  })
}

export function addLandingExperienceModel (data) {
  return fetch({
    url: '/api/common/landing-experience-model/add',
    method: 'Post',
    data: data
  })
}

export function updateLandingExperienceModel (data) {
  return fetch({
    url: '/api/common/landing-experience-model/update',
    method: 'Post',
    data: data
  })
}
